import { createApp } from "vue";
import App from "./App.vue"; // 根组件
import ElementPlus from "element-plus";
import "element-plus/dist/index.css"; // 引入 Element Plus 的样式
import router from "./router/index"; // 导入路由配置
import { createPinia } from 'pinia';

// 引入 ECharts
import * as echarts from "echarts";
const pinia = createPinia();


// 创建 Vue 应用
const app = createApp(App);
app.use(pinia);
// 注册 ECharts 到全局属性
app.config.globalProperties.$echarts = echarts;

// 注册 Element Plus 插件
app.use(ElementPlus);

// 注册路由
app.use(router);

// 挂载应用到 DOM
app.mount("#app");
